<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <vehicle-table />
      </div>
    </div>
    <!-- <div class="row">
      <div class="col-12">
        <projects-table />
      </div>
    </div> -->
  </div>
</template>

<script>
import VehicleTable from "./components/VehicleTable";
// import ProjectsTable from "./components/ProjectsTable";

export default {
  name: "tables",
  components: {
    VehicleTable,
    // ProjectsTable,
  },
};
</script>
